"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function AmazonredshiftGreenMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__amazonredshift-green-multitone-filled__clip0_13467_101)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M14.181 13.94c0 .27-.16.538-.47.788-.31.25-.766.477-1.34.668-.574.192-1.256.344-2.006.447-.75.104-1.554.157-2.366.157s-1.616-.053-2.366-.157a11.333 11.333 0 01-2.005-.447c-.575-.19-1.03-.418-1.34-.668-.311-.25-.471-.518-.471-.789V6.891h12.365v7.048z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    fillRule: "evenodd",
    d: "M2.516 1.363v-.001l.001-.007a.192.192 0 01.021-.042.838.838 0 01.197-.204C2.961.93 3.33.74 3.85.568 4.88.224 6.347 0 8 0c1.653 0 3.12.224 4.151.568.519.173.888.363 1.114.54.11.088.169.159.197.205a.189.189 0 01.022.049v.002l-.001.006a.189.189 0 01-.021.043.838.838 0 01-.197.203c-.226.178-.595.369-1.114.542-1.03.343-2.498.567-4.151.567-1.653 0-3.12-.224-4.15-.567-.52-.173-.89-.364-1.115-.542a.838.838 0 01-.197-.203.192.192 0 01-.022-.05z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    fillRule: "evenodd",
    d: "M2.516 1.363v-.001l.001-.007a.192.192 0 01.021-.042.838.838 0 01.197-.204c.031-.024.064-.049.1-.073h10.33c.036.024.069.049.1.073.11.087.169.158.197.204a.189.189 0 01.022.049v.002l-.001.006a.189.189 0 01-.021.043.838.838 0 01-.197.203c-.226.178-.595.369-1.114.542-1.03.343-2.498.567-4.15.567-1.654 0-3.122-.224-4.152-.567-.519-.173-.888-.364-1.114-.542a.838.838 0 01-.197-.203.192.192 0 01-.022-.05zm-.7 1.306v4.137c0 .271.16.539.471.789.311.25.767.477 1.34.669.575.191 1.256.343 2.006.446.75.104 1.554.157 2.366.157s1.616-.053 2.366-.157c.75-.103 1.432-.255 2.006-.446.574-.192 1.03-.419 1.34-.669.311-.25.471-.518.471-.789V2.67a3.012 3.012 0 01-.053.043c-.4.316-.936.57-1.536.77-1.208.402-2.832.639-4.593.639-1.761 0-3.385-.237-4.593-.64-.6-.2-1.136-.453-1.536-.769a2.833 2.833 0 01-.054-.044z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.436 8.095c-.74 0-1.305-.565-1.305-1.305 0-.739.566-1.304 1.305-1.304.74 0 1.305.565 1.305 1.304 0 .783-.566 1.305-1.305 1.305zm0-1.696c-.26 0-.435.174-.435.435 0 .26.174.435.435.435s.435-.174.435-.435-.174-.435-.435-.435zM9.74 11.53c-.74 0-1.305-.564-1.305-1.304 0-.74.565-1.305 1.304-1.305.74 0 1.305.566 1.305 1.305-.043.783-.609 1.305-1.305 1.305zm0-1.695c-.262 0-.436.174-.436.435 0 .26.174.435.435.435s.435-.174.435-.435c-.043-.261-.217-.435-.435-.435zM6.303 9.835C5.564 9.835 5 9.269 5 8.53c0-.74.565-1.305 1.304-1.305.74 0 1.305.566 1.305 1.305-.043.74-.609 1.305-1.305 1.305zm0-1.74c-.26 0-.435.174-.435.435s.174.435.435.435.435-.174.435-.435c-.043-.26-.217-.435-.435-.435zM4.564 13.27c-.74 0-1.305-.565-1.305-1.304 0-.74.566-1.305 1.305-1.305.74 0 1.305.566 1.305 1.305 0 .74-.566 1.305-1.305 1.305zm0-1.74c-.26 0-.435.175-.435.436 0 .26.174.435.435.435S5 12.227 5 11.966s-.174-.435-.435-.435z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.13 9.835c-.086 0-.13 0-.173-.044-.218-.087-.305-.348-.174-.565l.87-1.74c.086-.217.348-.304.565-.174.217.087.304.348.174.566l-.87 1.74a.457.457 0 01-.391.217zM5 11.53c-.088 0-.131 0-.175-.043-.217-.087-.304-.348-.174-.565l.87-1.74c.087-.217.348-.304.565-.174.218.087.305.348.174.566l-.87 1.74c-.086.173-.217.217-.39.217zM8.87 10.27c-.087 0-.13 0-.174-.044l-1.74-.87c-.217-.087-.304-.348-.174-.565.087-.217.348-.304.566-.174l1.74.87c.217.087.304.348.173.565a.457.457 0 01-.391.218z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__amazonredshift-green-multitone-filled__clip0_13467_101"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

AmazonredshiftGreenMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
AmazonredshiftGreenMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = AmazonredshiftGreenMultitoneFilled;
exports["default"] = _default;